var map = {
	"./filters/all_categories.svg": "7c61",
	"./filters/fashion_style.svg": "a5f9",
	"./filters/food_groceries.svg": "db50",
	"./filters/home_cars.svg": "21c9",
	"./filters/leisure_getaways.svg": "a279",
	"./filters/miscellaneous.svg": "714c",
	"./filters/mixed.svg": "e2c1",
	"./filters/restaurants_bars.svg": "581e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a93";